<template>
  <span
    class="inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold"
    :class="statusClass"
  >
    {{ statusLabel }}
  </span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  status: {
    type: String,
    default: "draft",
  },
});

const statusMap = {
  draft: {
    label: "Rascunho",
    class: "bg-yellow-50 text-yellow-700 border-yellow-100",
  },
  finished: {
    label: "Finalizado",
    class: "bg-green-50 text-green-700 border-green-100",
  },
  issued: {
    label: "Emitido",
    class: "bg-blue-50 text-blue-700 border-blue-100",
  },
  archived: {
    label: "Arquivado",
    class: "bg-gray-100 text-gray-500 border-gray-200",
  },
  signature_pending: {
    label: "Aguardando assinatura",
    class: "bg-purple-50 text-purple-700 border-purple-100",
  },
  signed: {
    label: "Assinado",
    class: "bg-emerald-50 text-emerald-700 border-emerald-100",
  },
};

const statusLabel = computed(() => {
  return statusMap[props.status]?.label || "Indefinido";
});

const statusClass = computed(() => {
  return (
    statusMap[props.status]?.class ||
    "bg-gray-100 text-gray-500 border-gray-200"
  );
});
</script>
